    //gotop
    $(function () {
      const $click = $('.gotop');
      $click.click(function () {
        $("html,body").animate({
          scrollTop: 0
        }, 1000)
      })
    })